module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"searchFieldPlaceholder":"Suche nach Adresse, Ort, Bezeichnung oder Nummer","searchButton":"Suchen"}}')
  delete Component.options._Ctor
}
